import { useState } from "react";

import { ExportModal, FactoryExportsTable, FactoryExportsToolbar } from "modules/FactoryExportsDashboard/components";

import type { FactoryExport } from "models";

export const FactoryExportsDashboard = () => {
  const [exportForModal, setExportForModal] = useState<FactoryExport | null>();

  return (
    <>
      <FactoryExportsToolbar onOpenAddExportModal={() => setExportForModal(null)} />
      <FactoryExportsTable onOpenEditExportModal={setExportForModal} />
      {exportForModal !== undefined && <ExportModal factoryExport={exportForModal} onClose={() => setExportForModal(undefined)} />}
    </>
  );
};
